<div class="dashboard-widget-content p-2">
    <rask-alert-list
        [data]="events$"
        title="Skogsvård">
    </rask-alert-list>
</div>
